export default {
      id: "oc-res-cluster-usage",
      viewBox: "0 0 1025 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-res-cluster",
      toString: function () {
        return this.url;
      }
    }